(function () {
  'use strict';

  var MOBILE_MQ = window.matchMedia('(max-width: 749px)');
  var GAP = 12;
  var DEFAULT_CHAT_INSET = 16;
  var CHAT_SIZE = 56;
  var TEASER_ABOVE_CHAT = 16;

  var ACTION_BTN_SELECTORS = [
    '#shopify-pc__banner__btn-accept',
    '.la-prescription-form-btn',
    '.product-form__submit',
    '.add-to-cart-btn',
    'lensadvizor-btn button',
    '.la-select-lenses-btn',
    '#la-select-lenses-btn',
    '.cart__checkout-button',
    '.floating-buttons-container button',
    '.book-mobile-fixed button',
  ];

  var CHAT_ROOT_SELECTORS = [
    '#shopify-chat',
    'shopify-chat',
    'inbox-online-store-chat',
    '#tidio-chat',
    '#tidio-chat-iframe',
    '[id^="tidio-"]',
    '.tidio-elements-container',
  ];

  var SHOPIFY_AGENT_SELECTOR = 'shopify-agent';

  var FULL_WIDTH_BAR_SELECTORS = [
    '.la-prescription-modal-footer.ciw-la-review-footer--pinned',
    '.la-prescription-modal-footer.ciw-la-subtotal-footer--ready',
    '.floating-buttons-container',
    '.book-mobile-fixed',
    '.fixed-bootom',
  ];

  var scheduled = null;
  var applying = false;
  var lastAppliedPx = null;
  var lastBottomChat = '';
  var lastBottomTeaser = '';

  function isMobile() {
    return MOBILE_MQ.matches;
  }

  function isLaModalOpen() {
    return document.body.classList.contains('la-modal-open');
  }

  function getChatRootSelectors() {
    if (!isLaModalOpen()) return CHAT_ROOT_SELECTORS;
    return CHAT_ROOT_SELECTORS.concat([SHOPIFY_AGENT_SELECTOR]);
  }

  function resetShopifyAgentBottom() {
    document.querySelectorAll(SHOPIFY_AGENT_SELECTOR).forEach(function (el) {
      el.style.removeProperty('bottom');
    });
  }

  function isVisible(el) {
    if (!el || el.hidden) return false;
    if (el.closest('[hidden], .ciw-shopify-pc-dismissed')) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity) === 0) {
      return false;
    }
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function rectsOverlap(a, b, pad) {
    var cushion = pad || 0;
    return !(
      a.right + cushion < b.left ||
      a.left - cushion > b.right ||
      a.bottom + cushion < b.top ||
      a.top - cushion > b.bottom
    );
  }

  function isNearViewportSized(rect) {
    if (!rect) return false;
    return rect.width >= window.innerWidth * 0.85 && rect.height >= window.innerHeight * 0.85;
  }

  function getChatRects() {
    var rects = [];

    getChatRootSelectors().forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        if (!isVisible(el)) return;

        var foundCompact = false;
        if (el.shadowRoot) {
          el.shadowRoot.querySelectorAll('button, [role="button"], a').forEach(function (btn) {
            if (!isVisible(btn)) return;
            var btnRect = btn.getBoundingClientRect();
            if (isNearViewportSized(btnRect)) return;
            rects.push(btnRect);
            foundCompact = true;
          });
        }

        /* shopify-chat host is often a full-viewport grid. Using that rect makes
           overlap math think the chat covers the whole page, then lifting the
           chat changes the math again -> clearance oscillates and UI flickers. */
        if (!foundCompact) {
          var hostRect = el.getBoundingClientRect();
          if (!isNearViewportSized(hostRect)) rects.push(hostRect);
        }
      });
    });

    return rects;
  }

  function getEstimatedChatRect() {
    return {
      left: window.innerWidth - DEFAULT_CHAT_INSET - CHAT_SIZE,
      right: window.innerWidth - DEFAULT_CHAT_INSET,
      top: window.innerHeight - DEFAULT_CHAT_INSET - CHAT_SIZE,
      bottom: window.innerHeight - DEFAULT_CHAT_INSET,
    };
  }

  function isPinnedToBottom(el) {
    var style = window.getComputedStyle(el);
    if (style.position !== 'fixed' && style.position !== 'sticky') return false;
    var rect = el.getBoundingClientRect();
    return window.innerHeight - rect.bottom < 24;
  }

  function getFullWidthBottomBarClearance() {
    var max = 0;

    FULL_WIDTH_BAR_SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        if (!isVisible(el)) return;
        if (!isPinnedToBottom(el)) return;

        var rect = el.getBoundingClientRect();
        if (rect.width < window.innerWidth * 0.7) return;

        max = Math.max(max, Math.ceil(rect.height + GAP));
      });
    });

    return max;
  }

  function getLensAdvisorModalClearance() {
    if (!document.body.classList.contains('la-modal-open')) return 0;

    var footer = document.querySelector('.la-prescription-modal-footer');
    if (!footer || !isVisible(footer)) return 0;

    var footerH = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--ciw-la-footer-h')
    );
    if (!(footerH > 0)) return 0;

    return Math.ceil(footerH + GAP);
  }

  function collectActionRects() {
    var items = [];
    var seen = new Set();

    ACTION_BTN_SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (btn) {
        if (!isVisible(btn) || seen.has(btn)) return;
        seen.add(btn);

        var target = findBottomPinnedBar(btn) || btn;
        var rect = target.getBoundingClientRect();
        if (rect.bottom < window.innerHeight - 320) return;

        items.push(rect);
      });
    });

    var banner = document.getElementById('shopify-pc__banner');
    if (banner && isVisible(banner) && !banner.classList.contains('ciw-shopify-pc-dismissed')) {
      items.push(banner.getBoundingClientRect());
    }

    return items;
  }

  function findBottomPinnedBar(el) {
    var node = el.parentElement;

    while (node && node !== document.body) {
      if (isPinnedToBottom(node)) return node;
      node = node.parentElement;
    }

    return null;
  }

  function computeIntersectionLift(chatRects, actionRects) {
    var lift = 0;

    actionRects.forEach(function (actionRect) {
      chatRects.forEach(function (chatRect) {
        var candidate = {
          left: chatRect.left,
          right: chatRect.right,
          top: chatRect.top - lift,
          bottom: chatRect.bottom - lift,
        };

        if (!rectsOverlap(candidate, actionRect, 4)) return;

        var needed = chatRect.bottom - actionRect.top + GAP;
        if (needed > lift) lift = needed;
      });
    });

    return Math.max(0, Math.ceil(lift));
  }

  function computeClearance() {
    /* Always evaluate overlap against the default docked chat button position.
       If we use the live elevated rect, lifting chat removes the overlap and
       clearance collapses to 0, then the next pass lifts again (flicker loop). */
    var chatRects = [getEstimatedChatRect()];
    var liveRects = getChatRects();
    if (liveRects.length) {
      /* Prefer real button size/x-position, but keep default bottom docking. */
      chatRects = liveRects.map(function (rect) {
        var width = Math.max(CHAT_SIZE, Math.min(rect.width || CHAT_SIZE, 72));
        var height = Math.max(CHAT_SIZE, Math.min(rect.height || CHAT_SIZE, 72));
        return {
          left: rect.left,
          right: rect.left + width,
          top: window.innerHeight - DEFAULT_CHAT_INSET - height,
          bottom: window.innerHeight - DEFAULT_CHAT_INSET,
        };
      });
    }

    var actionRects = collectActionRects();
    var intersectionLift = computeIntersectionLift(chatRects, actionRects);
    var barLift = getFullWidthBottomBarClearance();
    var laFooterLift = getLensAdvisorModalClearance();

    return Math.max(intersectionLift, barLift, laFooterLift);
  }

  function setBottomIfChanged(el, value) {
    if (!el || !el.style) return;
    if (el.style.getPropertyValue('bottom') === value) return;
    el.style.setProperty('bottom', value, 'important');
  }

  function applyClearance(px) {
    if (applying) return;
    applying = true;

    try {
      var bottomChat =
        'calc(' + px + 'px + ' + DEFAULT_CHAT_INSET + 'px + env(safe-area-inset-bottom, 0px))';
      var bottomTeaser =
        'calc(' + px + 'px + ' + TEASER_ABOVE_CHAT + 'px + env(safe-area-inset-bottom, 0px))';
      if (lastAppliedPx !== px) {
        document.documentElement.style.setProperty('--ciw-mobile-action-clearance', px + 'px');
        document.documentElement.classList.toggle('ciw-mobile-action-bar-active', px > 0);
        lastAppliedPx = px;
      }

      /* Always ensure bottoms on current nodes (new teaser/chat mounts), but
         setBottomIfChanged no-ops when the value is already correct. */
      getChatRootSelectors().forEach(function (selector) {
        document.querySelectorAll(selector).forEach(function (el) {
          setBottomIfChanged(el, bottomChat);
        });
      });

      document
        .querySelectorAll('#shopify-chat > iframe, iframe#dummy-chat-button-iframe')
        .forEach(function (el) {
          setBottomIfChanged(el, bottomChat);
        });

      document.querySelectorAll('[class*="kl-teaser-"]').forEach(function (el) {
        var isTeaser = Array.from(el.classList).some(function (className) {
          return className.indexOf('kl-teaser-') === 0;
        });
        if (!isTeaser) return;
        setBottomIfChanged(el, bottomTeaser);
      });

      lastBottomChat = bottomChat;
      lastBottomTeaser = bottomTeaser;

      if (!isLaModalOpen()) {
        resetShopifyAgentBottom();
      }
    } finally {
      applying = false;
    }
  }

  function clearClearance() {
    applying = true;
    try {
      document.documentElement.style.removeProperty('--ciw-mobile-action-clearance');
      document.documentElement.classList.remove('ciw-mobile-action-bar-active');

      getChatRootSelectors().forEach(function (selector) {
        document.querySelectorAll(selector).forEach(function (el) {
          el.style.removeProperty('bottom');
        });
      });

      document
        .querySelectorAll('#shopify-chat > iframe, iframe#dummy-chat-button-iframe')
        .forEach(function (el) {
          el.style.removeProperty('bottom');
        });

      document.querySelectorAll('[class*="kl-teaser-"]').forEach(function (el) {
        var isTeaser = Array.from(el.classList).some(function (className) {
          return className.indexOf('kl-teaser-') === 0;
        });
        if (!isTeaser) return;
        el.style.removeProperty('bottom');
      });

      resetShopifyAgentBottom();
      lastAppliedPx = null;
      lastBottomChat = '';
      lastBottomTeaser = '';
    } finally {
      applying = false;
    }
  }

  function sync() {
    if (applying) return;
    if (!isMobile()) {
      clearClearance();
      return;
    }

    applyClearance(computeClearance());
  }

  function scheduleSync() {
    if (applying || scheduled) return;
    scheduled = window.requestAnimationFrame(function () {
      scheduled = null;
      sync();
    });
  }

  function start() {
    sync();

    /* Do NOT observe style attributes: this script writes bottom/clearance
       styles, and watching those created a self-triggering flicker loop. */
    new MutationObserver(scheduleSync).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'hidden', 'aria-hidden'],
    });

    window.addEventListener('resize', scheduleSync, { passive: true });
    window.addEventListener('scroll', scheduleSync, { passive: true });
    MOBILE_MQ.addEventListener('change', sync);
    document.addEventListener('visitorConsentCollected', scheduleSync);

    var ticks = 0;
    var interval = window.setInterval(function () {
      scheduleSync();
      ticks += 1;
      if (ticks >= 40) window.clearInterval(interval);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
